import React, { useState } from 'react';
import { Button, Drawer, Tag } from 'antd';
import { RobotOutlined, CloseOutlined } from '@ant-design/icons';
import { useResponsive } from '../../hooks/useResponsive';
import AiChatPanel from './AiChatPanel';
import './AiChatWidget.css';

const AiChatWidget: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { isMobile } = useResponsive();

  if (isMobile) {
    return (
      <>
        <Button
          type="primary"
          shape="circle"
          icon={<RobotOutlined />}
          className="ai-chat-fab"
          onClick={() => setOpen(true)}
        />
        <Drawer
          title={
            <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              Asistente IA
              <Tag color="orange" style={{ margin: 0, fontSize: 11 }}>Beta</Tag>
            </span>
          }
          placement="bottom"
          height="100%"
          open={open}
          onClose={() => setOpen(false)}
          className="ai-chat-drawer"
          destroyOnClose
        >
          <AiChatPanel />
        </Drawer>
      </>
    );
  }

  return (
    <>
      <Button
        type="primary"
        shape="circle"
        icon={open ? <CloseOutlined /> : <RobotOutlined />}
        className="ai-chat-fab"
        onClick={() => setOpen(!open)}
      />
      {open && (
        <div className="ai-chat-panel">
          <div className="ai-chat-header">
            <div className="ai-chat-header-title">
              <RobotOutlined />
              Asistente IA
              <Tag color="orange" style={{ margin: 0, fontSize: 11, lineHeight: '18px' }}>Beta</Tag>
            </div>
            <Button
              type="text"
              size="small"
              icon={<CloseOutlined />}
              onClick={() => setOpen(false)}
            />
          </div>
          <AiChatPanel />
        </div>
      )}
    </>
  );
};

export default AiChatWidget;
